module.exports = __webpack_public_path__ + "img/erp-logos_0008_tencia.af14aba5.jpg";